import '@babel/polyfill'
import 'innersvg-polyfill'
import _ from 'lodash'
import Vue from 'vue'
import app from './www'
import * as types from './store/types'
import scroll from './support/scroll'

import 'lazysizes'

app.$store.commit(types.preload.mutations.got, window.preload)

/**
 * Require & Use
 */
require('./support/preload')

if (!_.preload('app.debug')) {
    Vue.use(require('@honeybadger-io/vue').default, {
        apiKey: _.preload('keys.honeybadger'),
        environment: _.preload('app.env'),
        revision: process.env.REVISION
    })
}

if (_.preload('keys.google-tag-manager')) {
    Vue.use(require('vue-gtm').default, {
        id: _.preload('keys.google-tag-manager'),
        enabled: true,
        debug: _.preload('app.debug')
    })
}

app.$router.beforeEach((to, from, next) => {
    Vue.prototype.$validator.reset()

    scroll.toTop()

    return next()
})

Vue.use(require('./plugins/track/plugin').default)
Vue.use(require('./plugins/screen/plugin').default)
Vue.use(require('./plugins/ssr/ssr').default, {
    enabled: false
})

Vue.use(require('vue-instantsearch').default)

Vue.component('algolia-get', require('./components/algolia-get').default)
Vue.component('algolia-places-get', require('./components/algolia-places-get').default)
Vue.component('base-dropdown', require('./components/base-dropdown').default)
Vue.component('image-carousel', require('./components/image-carousel').default)
Vue.component('on-click-outside', require('./components/on-click-outside').default)
Vue.component('on-escape', require('./components/on-escape').default)
Vue.component('on-window-resize', require('./components/on-window-resize').default)
Vue.component('with-dimensions', require('./components/with-dimensions').default)

app.$mount('#app')
